import Vue from 'vue'
import router from '@/router'
import { getInfo, getSystemList, logout, superLogin } from '@/api/login'
import { welcome, getAvatarText, getRandomColor } from '@/utils/util'
import { ACCESS_TOKEN, SSO_SYS_TOKEN } from '@/store/mutation-types'
import { session } from '@/plugin/session'
import { actions } from '@/microAppsConfig'

const user = {
  state: {
    token: '',
    name: '',
    userId: '',
    isTenantAdmin: false, // 是否是租户管理员（企业管理员）
    areaCode: '', // 区号
    mobile: '',
    newMobile: '',
    accountCode: '', // 用户账号
    accountStatus: '', // 用户状态
    defaultPwdFlag: '', // 是否是默认密码
    welcome: '',
    avatar: '',
    avatarBg: '',
    roles: [],
    roleTag: '',
    info: {},
    userList: [],
    systemList: JSON.parse(sessionStorage.getItem('ucs_system_list')) || [],
    number: 0, // 未读信息
    tenantFullName: '', // 租户名称
    tryoutUser: 0, // 是否访问水印开关接口
    proxyList: [],
    accountProxy: session.getItem('proxyUserInfo') || false, // 是否为代理状态
    proxyUserId: session.getItem('proxyUserInfo') ? session.getObject('proxyUserInfo').userId : '', // 代理对象的ID
    proxyUserName: session.getItem('proxyUserInfo') ? session.getObject('proxyUserInfo').userName : '', // 代理对象的NAME
    // 默认核算账簿
    default_account_book: {},
    // 默认公司
    default_company: {},
    // 有关用户文件上传下载的任务列表
    userFileTask: [],
    importDowloadVisible: false,
    importTipsVisible: false,
    statementTipsVisible: false,
    statementExecuteResult: {}
    // windowTabs: [] // TODO 控制子页面相关
  },

  mutations: {
    SET_NUMBER: (state, data) => {
      state.number = data
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_FULL_NAME: (state, tenantFullName) => {
      state.tenantFullName = tenantFullName
    },
    setTenantAdmin (state, type) {
      state.isTenantAdmin = type
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId
    },
    SET_AREA_CODE: (state, areaCode) => {
      state.areaCode = areaCode
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_NEW_MOBILE: (state, newMobile) => {
      state.newMobile = newMobile
    },
    SET_ACCOUNT_CODE: (state, accountCode) => {
      state.accountCode = accountCode
    },
    SET_ACCOUNT_STATUS: (state, accountStatus) => {
      state.accountStatus = accountStatus
    },
    SET_DEFAULT_PWD_FLAG: (state, defaultPwdFlag) => {
      state.defaultPwdFlag = defaultPwdFlag
    },
    SET_ROLE_TAG: (state, roleTag) => {
      state.roleTag = roleTag
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_AVATAR_BG: (state, avatarBg) => {
      state.avatarBg = avatarBg
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
      actions.setGlobalState({ fullAccountInfo: info })
    },
    SET_USER_LIST: (state, userList) => {
      state.userList = userList
    },
    SET_SYSTEM_LIST: (state, systemList) => {
      if (!systemList) return
      state.systemList = systemList?.map(item => {
        const { route } = item
        if (route === '/center') item.route = '/admin/index'
        return item
      })
      sessionStorage.setItem('ucs_system_list', JSON.stringify(systemList))
    },
    SET_TRYOUT_USER: (state, tryoutUser) => {
      state.tryoutUser = tryoutUser
    },
    SET_PROXY_LIST: (state, proxyList) => {
      state.proxyList = proxyList
    },
    SET_ACCOUNT_PROXY: (state, val) => {
      state.accountProxy = true
      state.proxyUserId = val.userId
      state.proxyUserName = val.userName
      session.setObject('proxyUserInfo', val)
    },
    // eslint-disable-next-line no-unused-vars
    CLEAR_ACCOUNT_PROXY: (state, val) => {
      state.accountProxy = false
      state.proxyUserId = ''
      state.proxyUserName = ''
      session.remove('proxyUserInfo')
    },
    // 设置默认核算账簿
    setAccountBook(state, accountBook) {
      state.default_account_book = accountBook
    },
    setDefaultCompany(state, company) {
      state.default_company = company
    },
    setUserFileTask(state, arr = []) {
      if (!(arr && arr.length > 0)) {
        state.importTipsVisible = false
      }
      state.userFileTask = arr
    },
    setImportDowloadVisible(state, visible) {
      state.importDowloadVisible = visible
    },
    setimportTipsVisible(state, visible) {
      state.importTipsVisible = visible
    },
    setStatementTipsVisible(state, visible) {
      state.statementTipsVisible = visible
    },
    setStatementExecuteResult(state, result) {
      state.statementExecuteResult = result
    }
  },

  actions: {
    // 登录
    Login({ dispatch }, userInfo) {
      return new Promise((resolve) => {
        dispatch('SetToken', userInfo.token)
        Vue.prototype.$cookie.set('systemName', 'UCS')
        resolve(userInfo)
      })
    },
    // 超级登录
    SuperLogin({ dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        superLogin(userInfo)
          .then(response => {
            const result = response.data
            dispatch('SetToken', result.ucsAuthenToken)
            Vue.prototype.$cookie.set('systemName', 'UCS')
            resolve(result)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return getInfo()
        .then(response => {
          if (!response) return Promise.resolve(response)
          const result = response.data
          let { currentUser } = result
          const { allUsers, id, mobile } = result
          if (!currentUser) {
            currentUser = { id, userName: mobile }
          }
          // 写入localStorage，提过给灵心使用
          localStorage.setItem('userinfo', JSON.stringify({
            ...currentUser,
            id: currentUser.id,
            userInfoId: currentUser.tumUserId,
            deptId: '',
            deptName: '',
            avatar: '',
            mobile,
            token: Vue.prototype.$cookie.get(ACCESS_TOKEN),
            roleList: []
          }))
          commit('SET_ACCOUNT_STATUS', result.accountStatus)
          commit('SET_DEFAULT_PWD_FLAG', result.defaultPwdFlag)
          commit('setTenantAdmin', currentUser.tenantAdminFlag)
          if (currentUser.tenantAdminFlag) {
            result.roles = ['admin']
            commit('SET_ROLE_TAG', '企业管理员')
          } else {
            result.roles = ['staff']
            commit('SET_ROLE_TAG', '普通员工')
          }
          if (!result.avatar) result.avatar = getAvatarText(currentUser.userName)
          if (result.roles && result.roles.length > 0) {
            commit('SET_USER_ID', currentUser.id)
            commit('SET_AREA_CODE', result.areaCode)
            commit('SET_MOBILE', result.mobile)
            commit('SET_USER_LIST', allUsers)
            commit('SET_ACCOUNT_CODE', result.accountCode)
            commit('SET_ROLES', result.roles)
            commit('SET_INFO', result)
            commit('SET_TRYOUT_USER', result.tryoutUser)
          } else {
            return Promise.reject(new Error('getInfo: roles must be a non-null array !'))
          }
          // currentUsercurrentUser
          commit('SET_FULL_NAME', currentUser.tenantFullName)
          commit('SET_NAME', { name: currentUser.userName, welcome: welcome() })
          commit('SET_AVATAR', result.avatar)
          const color = localStorage.getItem(`${result.id}_avatar_bg`)
          if (color && color !== 'undefined' && color !== 'null') {
            commit('SET_AVATAR_BG', color)
          } else {
            localStorage.setItem(`${result.id}_avatar_bg`, getRandomColor())
            commit('SET_AVATAR_BG', localStorage.getItem(`${result.id}_avatar_bg`))
          }
          return Promise.resolve(result)
        })
        .catch(error => {
          return Promise.reject(error)
        })
        // .finally(() => {
        //   const timer = setTimeout(() => {
        //     if (vm && vm.$loading) {
        //       vm.$loading.hide()
        //     }
        //     clearTimeout(timer)
        //   }, 500)
        // })
    },

    // 获取首页子系统菜单
    GetSystemList({ commit }) {
      return getSystemList().then(res => {
        commit('SET_SYSTEM_LIST', res.data)
        return res.data
      })
    },
    // 设置代理状态
    setAccountProxy({ commit }, val) {
      const isSet = !!val
      if (isSet) {
        commit('SET_ACCOUNT_PROXY', val)
      } else {
        commit('CLEAR_ACCOUNT_PROXY', val)
      }
      location.href = '/ucs/ems/index'
    },
    // AddWindowTab ({ commit, state }, tab) { // TODO 控制子页面相关
    //   const tabs = [...state.windowTabs, tab].filter(item => !item.closed)
    //   commit('SET_WINDOW_TABS', tabs)
    // },
    // RemoveWindowTab ({ commit, state }, tab) { // TODO 控制子页面相关
    //   const tabs = state.windowTabs.filter(item => item.name !== tab.name)
    //   commit('SET_WINDOW_TABS', tabs)
    // },

    // 登出
    Logout({ dispatch }) {
      if (Vue.prototype.$cookie.get(ACCESS_TOKEN)) {
        // if (state.windowTabs.length) { // 如果有打开新的子系统页面 // TODO 控制子页面相关
        //   state.windowTabs.forEach(item => {
        //     item.close()
        //   })
        //   commit('SET_WINDOW_TABS', [])
        // }
        return logout().then(() => {
          dispatch('logoutTabs')
          dispatch('ClearToken', { toLogin: true })
          // setTimeout(() => {
          //   window.location.reload()
          // }, 1000)
          // Vue.prototype.$showLogin()
          // router.push({ name: 'CommonLogin' })
          // location.reload()
        })
      } else {
        // setTimeout(() => {
        //   window.location.reload()
        // }, 20)
        // Vue.prototype.$showLogin()
        // window.location.reload()
        router.push({ name: 'CommonLogin' })
      }
      // return new Promise((resolve, reject) => {
      //   commit('SET_TOKEN', '')
      //     Vue.ls.remove(ACCESS_TOKEN)
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 0)

      //   logout(state.token).then(() => {
      //     resolve()
      //   }).catch(() => {
      //     // eslint-disable-next-line prefer-promise-reject-errors
      //     reject()
      //   }).finally(() => {
      //     commit('SET_TOKEN', '')
      //     Vue.ls.remove(ACCESS_TOKEN)
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 0)
      //   })
      // })
    },
    ClearToken({ commit }, params) {
      if (Vue.prototype.$cookie.get(ACCESS_TOKEN) || Vue.prototype.$cookie.get(SSO_SYS_TOKEN)) {
        commit('SET_TOKEN', '')
        Vue.prototype.$cookie.remove(ACCESS_TOKEN)
        Vue.prototype.$cookie.remove(SSO_SYS_TOKEN)
      }
      if (params && params.toLogin) {
        router.push({ name: 'CommonLogin' })
      }
    },
    SetToken({ commit }, token) {
      commit('SET_TOKEN', token)
      if (!Vue.prototype.$cookie.get(ACCESS_TOKEN) || Vue.prototype.$cookie.get(ACCESS_TOKEN) !== token) {
        Vue.prototype.$cookie.set(ACCESS_TOKEN, token)
      }
      if (!Vue.prototype.$cookie.get(SSO_SYS_TOKEN) || Vue.prototype.$cookie.get(SSO_SYS_TOKEN) !== token) {
        Vue.prototype.$cookie.set(SSO_SYS_TOKEN, token)
      }
    }
  }
}

export default user
